import { ApiBase } from './apiBase';
import { METHOD } from '../constant/api';

export class ApiToken extends ApiBase {
  private static baseUrl: string = '/token';

  static async post(email: string, password: string): Promise<any> {
    const url = this.baseUrl;

    const data = {
      mail: email,
      password: password,
    };

    const config = {};

    return await this.sendRequest(METHOD.POST, url, data, config)
      .then((value) => {
        return value;
      })
      .catch((error) => {
        throw error;
      });
  }
}
